
{
  "actions": {
    "add": "Add Locations"
  },
  "empty": "No locations selected"
}
